var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.638,
    height: 22.515,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 1283"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 1282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.638 5.16v13.602a3.763 3.763 0 0 1-3.752 3.753h-6.848a3.746 3.746 0 0 1-2.674-1.117L0 13.912s1.182-1.154 1.22-1.172c.206-.179.46-.273.74-.273.207 0 .395.057.564.15.037.01 4.043 2.308 4.043 2.308V3.752c0-.778.628-1.407 1.407-1.407s1.407.629 1.407 1.407v6.567h.938V1.407C10.32.63 10.948 0 11.726 0c.779 0 1.408.629 1.408 1.407v8.912h.938V2.345c0-.778.628-1.407 1.407-1.407.778 0 1.407.629 1.407 1.407v7.974h.938V5.16c0-.778.629-1.407 1.407-1.407.779 0 1.407.629 1.407 1.408Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 348"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.47442ecf870cfb38f5f9d290e028d9f2.svg";
export { ForwardRef as ReactComponent };